import { Epic, ofType } from 'redux-observable';
import { IshState } from '../../services/IshState';
import { Observable, mergeMap } from 'rxjs';
import {
  getAmount, setRedeemVoucherProductActivity,
  TOGGLE_REDEEM_VOUCHER_PRODUCT,
} from '../actions/Actions';
import { IAction } from '../../actions/IshAction';

const EpicToggleRedeemVoucherProduct: Epic<any, IshState> = (action$: Observable<any>): Observable<any> => {
  return action$.pipe(
    ofType(TOGGLE_REDEEM_VOUCHER_PRODUCT),
    mergeMap((action:IAction<any>) => {

      const payload = action.payload;

      return [
        setRedeemVoucherProductActivity(payload.voucher.id, payload.enabled),
        getAmount(),
      ];
    })
  );
};

export default EpicToggleRedeemVoucherProduct;

